import { render } from "./LinkTreeLoader.vue?vue&type=template&id=72921fb0&scoped=true"
import script from "./LinkTreeLoader.vue?vue&type=script&lang=js"
export * from "./LinkTreeLoader.vue?vue&type=script&lang=js"

import "./LinkTreeLoader.vue?vue&type=style&index=0&id=72921fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72921fb0"]])

export default __exports__